import {EcommerceDashboardPeriod} from 'web-angular-client';
import {DropdownItem} from '../../sdk/interface/data/DropdownItem';

/**
 * Period presets for the ecommerce **dashboard**. Kept to short windows because the dashboard's balance bar and
 * stats are an at-a-glance view — long ranges belong on the transactions page where the CSV export lives.
 */
export const ECOMMERCE_PERIOD_OPTIONS: DropdownItem[] = [
    {label: 'Today', value: EcommerceDashboardPeriod.TODAY},
    {label: 'Yesterday', value: EcommerceDashboardPeriod.YESTERDAY},
    {label: '7 Days', value: EcommerceDashboardPeriod.LAST_7_D},
    {label: '30 Days', value: EcommerceDashboardPeriod.LAST_30_D},
    {label: 'Month to Date', value: EcommerceDashboardPeriod.MTD}
];

/**
 * Period presets for the ecommerce-**transactions** page. Same short windows as the dashboard plus the longer
 * 3-/6-month ranges, which are useful when exporting a wider span of transactions to CSV.
 */
export const ECOMMERCE_TRANSACTIONS_PERIOD_OPTIONS: DropdownItem[] = [
    ...ECOMMERCE_PERIOD_OPTIONS,
    {label: '3 Months', value: EcommerceDashboardPeriod.LAST_3_M},
    {label: '6 Months', value: EcommerceDashboardPeriod.LAST_6_M}
];
